// Tipos de unidad (apartments.unitKind).
//
//  - "normal": la unidad de siempre (propietario/inquilino, paga gastos comunes).
//  - "porteria": vivienda del portero. Es del edificio, no paga gastos comunes ni
//    fondos y sus ocupantes NO tienen acceso de residente (functions/lib/access.js).
//  - "alquiler_edificio" ("Alquiler del edificio", 30-oct-2026): unidad que el
//    edificio alquila a un tercero (portería alquilada, local, cochera). No tiene
//    propietario (el dueño es el edificio), no paga gastos comunes ni fondos y no
//    vota en asambleas; su inquilino SÍ tiene acceso de residente y paga el
//    alquiler por la plataforma (contrato en `alquileres/{apartmentId}`).
//
// El servidor guarda el tipo normalizado (minúsculas); acá se normaliza igual por
// si llega un dato viejo. Espejo en functions/lib/unitKinds.js y
// propia_agent/unidades_tipo.py.

export const UNIT_KIND_NORMAL = "normal";
export const UNIT_KIND_PORTERIA = "porteria";
export const UNIT_KIND_ALQUILER = "alquiler_edificio";
export const UNIT_KINDS = [UNIT_KIND_NORMAL, UNIT_KIND_PORTERIA, UNIT_KIND_ALQUILER];

const ETIQUETAS = {
  [UNIT_KIND_NORMAL]: "Normal",
  [UNIT_KIND_PORTERIA]: "Portería",
  [UNIT_KIND_ALQUILER]: "Alquiler del edificio",
};

/** Tipo de la unidad normalizado; cualquier valor desconocido es "normal". */
export function normKind(apt) {
  const k = typeof apt?.unitKind === "string" ? apt.unitKind.trim().toLowerCase() : "";
  return UNIT_KINDS.includes(k) ? k : UNIT_KIND_NORMAL;
}

/** Unidad del edificio (portería o alquiler del edificio): fuera de gastos comunes,
 *  fondos, padrón de asambleas, tablas por unidad y KPIs de morosidad. */
export function esUnidadDelEdificio(apt) {
  const k = normKind(apt);
  return k === UNIT_KIND_PORTERIA || k === UNIT_KIND_ALQUILER;
}

/** Unidad que el edificio alquila con contrato (su inquilino paga alquiler). */
export function esAlquilerDelEdificio(apt) {
  return normKind(apt) === UNIT_KIND_ALQUILER;
}

/** Sus ocupantes tienen acceso de residente (todas menos la portería). */
export function daAccesoResidente(apt) {
  return normKind(apt) !== UNIT_KIND_PORTERIA;
}

/** Pago que lleva alquiler de una unidad del edificio (lo arma el cierre). */
export function esPagoDeAlquiler(p) {
  return p?.concepto === "alquiler" || Number(p?.rentAmount) > 0 || Number(p?.breakdown?.alquiler) > 0;
}

/** Etiqueta para mostrar el tipo de unidad. */
export function etiquetaTipoUnidad(aptOKind) {
  const kind = typeof aptOKind === "string" ? normKind({ unitKind: aptOKind }) : normKind(aptOKind);
  return ETIQUETAS[kind];
}
